export default __webpack_public_path__ + "static/media/abmalogowhite.dd1b5463.png";